export const externalLinks = {
  termsOfService:
    'https://workdrive.zohoexternal.com/file/m6pef254d7d5346a84209b36c911b7f5de28c',
  privacyPolicy:
    'https://workdrive.zohoexternal.com/file/m6pefd3c72466b2fb46808cf4fcd291f5c17f',
  calendlyCEO: 'https://calendly.com/oliver-kazinihr/30min',
  login: 'https://app.kazinihr.co.ke/login',
};
